"use strict";

exports.__esModule = true;
exports.default = void 0;
var useRandomId = function useRandomId(id) {
  if (id) {
    return id;
  }
  var randomString = function randomString(len, an) {
    an = an && an.toLowerCase();
    var str = '',
      i = 0,
      min = an === 'a' ? 10 : 0,
      max = an === 'n' ? 10 : 62;
    for (; i++ < len;) {
      var r = Math.random() * (max - min) + min << 0;
      str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
    }
    return str;
  };

  // const randomId = [...Array(8)].map(() => ((Math.random() * 36) | 0).toString(36)).join("");
  var randomId = randomString(8);
  return "rdId-" + randomId;
};
var _default = exports.default = useRandomId;